export const menuPermission: any = {
	// [UserRole.ROLE_WEB_ADMIN]: [
	// 	'/',
	// 	'/pre-admission',
	// 	'/pre-admission/pre-admission-list/*',
	// ],
	// [UserRole.ROLE_WEB_STAFF]: [
	// 	'/',
	// 	'/pre-admission',
	// 	'/pre-admission/pre-admission-list/*',
	// ],
};
